'use strict';

var scrollBarUtil = require('../utils/scrollBarUtil');

module.exports = function () {
    const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
    var $dropdownToggle = $('.dropdown:not(.disabled) .desktop-redirection');
    var selectedGeographyCountry;

    /**
     * Resets the Level 2 (L2) flyout menu state for desktop view.
     *
     * This function:
     * - Hides all `.category-tabs-modal` elements inside `.l2-category-item` by adding the `d-none` class.
     * - Removes the `show` class from all `.l2-category-item` elements.
     * - Hides all `.right-arrow` elements inside `.l2-category-item` by adding the `d-none` class.
     *
     * Typically used when closing or resetting the L2 navigation menu to its default hidden state.
     *
     * @function resetL2FlyoutDesk
     * @returns {void} This function does not return anything.
     */
    function resetL2FlyoutDesk() {
        $('.l2-category-item').find('.category-tabs-modal').addClass('d-none');
        $('.l2-category-item').removeClass('show');
        $('.l2-category-item').find('.right-arrow').addClass('d-none');
    }

    /**
     * Closes the mobile mega navigation menu and resets its state.
     *
     * This function:
     * - Removes the `show-mobile-menu` class from the mobile nav container.
     * - Removes the `overflow-hidden` class from the body to allow scrolling again.
     * - Collapses any open accordion sections inside the mega nav.
     * - Adds the `collapsed` class back to all toggler elements.
     * - Hides the category tabs modal by adding the `d-none` class.
     *
     * @function closeMegaNav
     * @returns {void} - This function does not return a value.
     */
    function closeMegaNav() {
        var $mobNav = $('.mob-nav .header-navbar');
        $mobNav.removeClass('show-mobile-menu'); // closes mega nav on mobile
        $('body').removeClass('overflow-hidden');
        $mobNav.find('.collapse.show').collapse('hide'); // resets accordion
        $mobNav.find('[data-toggle="collapse"]').addClass('collapsed');
        $('.category-tabs-modal').addClass('d-none');
        $('.modal-background').hide();
    }

    /**
     * Closes the mega navigation depending on screen size.
     *
     * - On screens < 1024px:
     *   - Removes `.show` classes from L1 and L2 category items.
     *   - Adds `.d-lg-none` to `.category-backdrop`.
     *   - Resets inline styles (`top`, `height`) for `.category-backdrop`.
     *   - Removes body scroll restrictions and padding.
     *   - Calls `resetL2FlyoutDesk()` for L2 flyout reset.
     *
     * - On screens ≥ 1024px:
     *   - Calls `closeMegaNav()` for desktop behavior.
     *
     * @function closeMegaNavInResponsive
     * @returns {void}
     */
    function closeMegaNavInResponsive() {
        if ($(window).width() < 1024) {
            $('.l2-category-items').scrollTop(0);
            $('.l2-category-items.show').collapse('hide');
            $('.l1-category-item').removeClass('show');
            $('.l1-category-item').find('.l2-category-items').removeClass('show');
            $('.mobile-category-item').addClass('collapsed').attr('aria-expanded', 'false');
            $('.l1-category-item').find('.category-backdrop').addClass('d-lg-none');
            // Reset inline styles applied for top/height when hiding the flyout
            $('.category-backdrop').css({ top: '', height: '' });
            $('body').removeClass('back-ground-scroll overflow-hidden');
            $('body').css('padding-right', 0 + 'px');
            resetL2FlyoutDesk();
        } else {
            closeMegaNav();
        }
    }

    /**
     * Handles window resize behavior for tablet and mobile screens (≤ 1024px).
     *
     * - Closes and hides the region modal.
     * - Resets all country accordion bodies by collapsing them
     *   and removing inline styles.
     * - Forces accordion headers into a collapsed state
     *   and updates accessibility attributes.
     *
     * This function is typically called on window resize
     * to ensure UI consistency across screen sizes.
     *
     * @function handleResize
     * @returns {void}
     */
    function handleResize() {
        if (window.innerWidth <= 1024) {
            // Close & hide modal
            $('#regionModal').modal('hide').addClass('d-none');

            // Reset accordion bodies
            $('.accordion-country-body').each(function () {
                $(this)
                    .removeClass('show')
                    .removeAttr('style')
                    .collapse({ toggle: false });
            });

            // Add collapsed state to headers
            $('.open-country-modal')
                .addClass('collapsed')
                .attr('aria-expanded', 'false');
        }
    }

    /**
     * Restores the default active state for level-3 tabs within a submenu panel.
     *
     * @param {jQuery} $container - Submenu wrapper containing the tab navigation and panes.
     * @returns {void}
     */
    function resetL3MenuTabs($container) {
        $container.find('.l3-category-tabs .nav-link').removeClass('active');
        $container.find('.l4-categories-container .tab-pane').removeClass('show active');
        $container.find('.l3-category-tabs .l3-category-tab-item:first-child .nav-link').addClass('active');
        $container.find('.l4-categories-container .tab-pane:first-child').addClass('show active');
    }

    /**
     * Removes duplicate submenu IDs from the desktop header copy while the mobile nav is active.
     *
     * @returns {void}
     */
    function removeDesktopMenuIdsForMobile() {
        $('header .l2-category-items, header .category-tabs-modal, header .tab-pane').removeAttr('id');
    }

    /**
     * Opens a desktop level-1 dropdown and applies the page scroll/backdrop state it expects.
     *
     * @param {jQuery} $parent - The hovered top-level category item.
     * @returns {void}
     */
    function openDesktopDropdown($parent) {
        $('.more-section-accodian-body .countrys-wrap-list, .country-region-container').scrollTop(0);
        $('.more-section-accodian-body').removeClass('show');
        $('.more-first-set-accordian').addClass('collapsed');
        $('.more-active-section').addClass('collapse');

        $parent.addClass('show');
        $parent.find('.l2-category-items').addClass('show');

        var visibleHeaderHeight = $('header')[0].getBoundingClientRect().bottom - 1;
        var categoryBackdropHeight = visibleHeaderHeight + 135;

        $('.category-backdrop').css({
            top: visibleHeaderHeight + 'px',
            height: 'calc(100% - ' + categoryBackdropHeight + 'px)'
        });

        $parent.find('.category-backdrop').removeClass('d-lg-none');

        $('body').addClass('back-ground-scroll');
        scrollBarUtil.applyScrollbarPadding();
        $('body').addClass('overflow-hidden');
    }

    /**
     * Closes a desktop level-1 dropdown and clears the backdrop/body adjustments.
     *
     * @param {jQuery} $parent - The top-level category item being closed.
     * @returns {void}
     */
    function closeDesktopDropdown($parent) {
        $parent.removeClass('show');
        $parent.find('.l2-category-items').scrollTop(0);
        $parent.find('.l2-category-items').removeClass('show');
        $parent.find('.category-backdrop').addClass('d-lg-none');
        $('.category-backdrop').css({ top: '', height: '' });
        $('body').removeClass('back-ground-scroll overflow-hidden');
        $('body').css('padding-right', 0 + 'px');
        resetL2FlyoutDesk();
    }

    /**
     * Fetches and injects the deferred menu fragment for a top-level category once.
     *
     * @param {jQuery} $categoryItem - The level-1 category item that owns the lazy slot.
     * @returns {jQuery.Promise} Resolves when the fragment request finishes successfully.
     */
    function loadMenuItem($categoryItem) {
        if (!$categoryItem.length) {
            var missingCategoryDeferred = $.Deferred();
            missingCategoryDeferred.reject();
            return missingCategoryDeferred.promise();
        }

        if ($categoryItem.data('menuItemLoaded')) {
            return $.when();
        }

        var existingRequest = $categoryItem.data('menuItemRequest');
        if (existingRequest) {
            return existingRequest;
        }

        var menuItemUrl = $categoryItem.data('menuItemUrl');
        var $slot = $categoryItem.find('.js-menu-item-container').first();

        if (!menuItemUrl || !$slot.length) {
            var missingMarkupDeferred = $.Deferred();
            missingMarkupDeferred.reject();
            return missingMarkupDeferred.promise();
        }

        var request = $.ajax({
            url: menuItemUrl,
            type: 'get',
            dataType: 'html'
        }).done(function (response) {
            var renderedHtml = $.trim(response);

            if (!renderedHtml) {
                return;
            }

            $slot.html(renderedHtml);
            $categoryItem
                .attr('data-menu-item-loaded', 'true')
                .data('menuItemLoaded', true);
        }).always(function () {
            $categoryItem.removeData('menuItemRequest');
        });

        $categoryItem.data('menuItemRequest', request);

        return request;
    }

    /**
     * Highlights the selected country across accordion and modal lists.
     *
     * @param {string} abbreviation - Selected country abbreviation.
     */
    function updateSelectedCountryStyles(abbreviation) {
        if (!abbreviation) {
            return;
        }

        $('.country-item.country-flag-and-name .country-name').removeClass('selected');
        $('.country-region-container .country-region').removeClass('selected');
        $('#dynamicCountryList .country-name').removeClass('selected');

        var $matchingCountryItems = $('.country-item.country-flag-and-name[data-abbreviation="' + abbreviation + '"]');

        if ($matchingCountryItems.length) {
            $matchingCountryItems.find('.country-name').addClass('selected');
            var regionName = $matchingCountryItems.first().closest('.country-data-list').data('region');
            $('.country-region-container .country-region[data-region="' + regionName + '"]').addClass('selected');
        }

        $('#dynamicCountryList .countries[data-abbreviation="' + abbreviation + '"] .country-name').addClass('selected');
    }

    /**
     * Updates the selected country/region by setting the flag,
     * updating locale and currency, and handling UI/navigation changes.
     *
     * - Sends an AJAX request to update the selected region.
     * - Handles restricted locale/currency changes.
     * - Updates the geography flag image.
     * - Replaces the navigation menu if a new one is returned.
     * - Redirects the user after successful update.
     *
     * @function countryFlagSet
     * @param {string} imageUrl - URL of the selected country flag image.
     * @param {string} regionKey - Locale/region key to be set.
     * @param {string} currencyCode - Currency code associated with the region.
     * @param {string} url - Endpoint URL for updating region/locale.
     * @returns {void}
     */
    function countryFlagSet(imageUrl, regionKey, currencyCode, url) {
        if (regionKey) {
            var urlParams = new URLSearchParams(window.location.search);
            var isLoyaltyPage = urlParams.get('page') === 'loyaltypoints';

            if (isLoyaltyPage) {
                $('#regionModal').modal('hide');
                var toastMessageHelper = require('../utils/toastMessageHelper');
                var message = $('.loyalty-enrollment-restriction-msg').val();
                toastMessageHelper.showNotification(message);
                return;
            }

            var regionSelected = true;
            $.ajax({
                url: url,
                type: 'get',
                dataType: 'html',
                data: {
                    localeUpdateValue: regionKey,
                    regionSelected: regionSelected,
                    imageUrl: imageUrl,
                    currencyCode: currencyCode
                },
                success: function (data) {
                    if (data) {
                        let templateObject = typeof data === 'string' ? JSON.parse(data) : data;

                        if (templateObject.error) {
                            $('#regionModal').modal('hide');
                            $.spinner().stop();
                            $('#currency-or-locale-change-restricted').modal('show');
                            return;
                        }

                        // Update the geography-flag image src
                        $('.geography-flag').find('img').attr('src', imageUrl);

                        if (templateObject.renderedTemplate) {
                            var tempContainer = $('<div>').html(templateObject.renderedTemplate);
                            var newMenu = tempContainer.find('ul.nav.navbar-nav');
                            if (newMenu.length) {
                                $('ul.nav.navbar-nav').replaceWith(newMenu);
                            }
                        }
                        $('#regionModal').modal('hide');
                        window.location.href = templateObject.redirectUrl;
                    }
                    $.spinner().stop();
                    selectedGeographyCountry = regionKey;
                    updateSelectedCountryStyles(selectedGeographyCountry);
                },
                error: function () {
                    $.spinner().stop();
                }
            });
        }
    }

    /**
     * Initializes responsive behavior for the Mega Navigation (meganav).
     *
     * - On screens ≤ 1024px (mobile/tablet):
     *   - Disables default anchor navigation for dropdown toggles.
     *   - Handles showing/hiding category modals via `.dropdown-link.dropdown-toggle`.
     *   - Adds back-navigation for category modals (`.back-arrow`).
     *   - Controls country accordion expand/collapse with `.open-country-modal`.
     *   - Updates selected country flag when a `.country-item` is clicked.
     *   - Closes mega-nav on `.close-category` or header click.
     *   - Removes `id` attributes from `.category-tabs-modal` and `.tab-pane` to avoid duplicate IDs.
     *   - Ensures only one L1 accordion is open at a time.
     *
     * - On screens > 1024px (desktop):
     *   - Opens L1 categories on hover (`mouseenter`) and sets backdrop height dynamically.
     *   - Resets search suggestion, language, currency, and "more" sections on hover.
     *   - Resets L2 flyouts when leaving sections.
     *   - Manages L2 category hover with default first tab activation.
     *   - Toggles "More" dropdown differently for touch vs. non-touch devices.
     *   - Loads dynamic country list and displays `#regionModal` when `.open-country-modal` is clicked.
     *
     * @function meganavResponsive
     * @returns {void}
     */
    function meganavResponsive() {
        if ($(window).width() < 1024) {
            // Clear desktop-specific handlers to avoid hover/collapse conflicts after resize.
            $('.dropdown:not(.disabled), .category-backdrop').off('.menuDesktop');
            $('.l2-category-item').off('.menuDesktop');
            $('.l2-category-items').off('.menuDesktop');
            $('.top-navbar-right .more-div, .more-active-section').off('.menuDesktop');
            $('.open-country-modal').off('.menuDesktop');
            $(document).off('.menuDesktop');

            $dropdownToggle.off('click.menuMobile').on('click.menuMobile', function (e) {
                e.preventDefault();
            });

            $('.mobile-category-item').off('click.menuMobileLazyLoad').on('click.menuMobileLazyLoad', function (e) {
                var $trigger = $(this);
                var $categoryItem = $trigger.closest('.l1-category-item');

                if ($categoryItem.data('menuItemLoaded')) {
                    return;
                }

                e.preventDefault();
                e.stopImmediatePropagation();

                loadMenuItem($categoryItem).done(function () {
                    meganavResponsive();
                    var targetSelector = $trigger.attr('href');
                    var $target = $categoryItem.find(targetSelector).first();

                    if ($target.length) {
                        $target.collapse('show');
                        $trigger.removeClass('collapsed').attr('aria-expanded', 'true');
                    }
                });
            });

            $('.dropdown-link.dropdown-toggle').off('click.menuMobile').on('click.menuMobile', function (e) {
                e.preventDefault(); // Optional: prevents the default anchor behavior

                // Get the target modal's ID from data-target
                const modalId = $(this).data('target');

                // Hide all modals first (optional, if you want to show only one at a time)
                // $('.category-tabs-modal').addClass('d-none');

                // Show the relevant modal by removing d-none
                $(modalId).removeClass('d-none');
            });

            $('.back-arrow').off('click.menuMobile').on('click.menuMobile', function () {
                $('.category-tabs-modal').addClass('d-none');
                const $parent = $(this).closest('.modal-content-wrapper');
                resetL3MenuTabs($parent);
            });

            $('.geography-section').off('click.menuMobile').on('click.menuMobile', function () {
                // If parent accordion is being closed
                if (!$(this).hasClass('collapsed')) {
                    // Reset all child region headers
                    $('.open-country-modal')
                        .addClass('collapsed')
                        .attr('aria-expanded', 'false');

                    // Close all child accordions properly
                    $('.accordion-country-body').collapse('hide');
                }
            });

            $('.open-country-modal').off('click.menuMobile').on('click.menuMobile', function () {
                var $clicked = $(this);
                var clickedRegion = $clicked.data('region');
                var targetId = '#countries-accordion-' + clickedRegion;

                // Close all other accordion bodies
                $('.accordion-country-body').not(targetId).collapse('hide');

                // Reset all region headers
                $('.open-country-modal')
                    .addClass('collapsed')
                    .attr('aria-expanded', 'false');

                // Toggle only the clicked one
                if ($(targetId).hasClass('show')) {
                    $(targetId).collapse('hide');
                    $clicked.addClass('collapsed').attr('aria-expanded', 'false');
                } else {
                    $(targetId).addClass('show');
                    $clicked.removeClass('collapsed').attr('aria-expanded', 'true');
                }
            });

            // Run once on load
            handleResize();

            // Bind resize only once
            $(window).off('resize.regionAccordion').on('resize.regionAccordion', handleResize);

            $('.country-item.country-flag-and-name').off('click.menuMobile').on('click.menuMobile', function () {
                var imageUrl = $(this).data('image');

                // 1. Get region from parent <ul data-region="...">
                var region = $(this).closest('.country-data-list').data('region');

                // 3. Trigger .open-country-modal only if it's not collapsed
                var $targetModal = $('.open-country-modal[data-region="' + region + '"]');
                if ($targetModal.length && !$targetModal.hasClass('collapsed')) {
                    $targetModal.trigger('click');
                }

                // 4. Trigger .geography-section
                $('.geography-section').trigger('click');

                // 2. Update image inside .geography-flag
                $('.geography-flag').find('img').attr('src', imageUrl);
            });

            $('.close-category').off('click.menuMobile').on('click.menuMobile', function () { // on click of mega-nav close btn mobile
                closeMegaNav();
            });
            $(document).off('click.menuMobileClose', 'header, .modal-background').on('click.menuMobileClose', 'header, .modal-background', function () {
                if ($('.mob-nav .header-navbar').hasClass('show-mobile-menu')) {
                    closeMegaNav();
                }
            });
            removeDesktopMenuIdsForMobile();

            // Keep top-level mobile accordion behavior consistent between L1 and "More" sections.
            $(document).off('show.bs.collapse.menuL1Accordion', '.categories-and-more-section-wrapper .l2-category-items, .categories-and-more-section-wrapper .countries-more-section #more-section')
                .on('show.bs.collapse.menuL1Accordion', '.categories-and-more-section-wrapper .l2-category-items, .categories-and-more-section-wrapper .countries-more-section #more-section', function (e) {
                    if (e.target !== this) return;
                    $('.categories-and-more-section-wrapper .l2-category-items.show, .categories-and-more-section-wrapper .countries-more-section #more-section.show')
                        .not(this)
                        .collapse('hide');
                    $('.categories-and-more-section-wrapper .countries-more-section .more-title').addClass('collapsed');
                });
        } else {
            // Clear mobile-specific handlers to avoid duplicate click/collapse behavior on desktop.
            $dropdownToggle.off('.menuMobile');
            $('.mobile-category-item').off('.menuMobileLazyLoad');
            $('.dropdown-link.dropdown-toggle').off('.menuMobile');
            $('.back-arrow').off('.menuMobile');
            $('.geography-section').off('.menuMobile');
            $('.open-country-modal').off('.menuMobile');
            $('.country-item.country-flag-and-name').off('.menuMobile');
            $('.close-category').off('.menuMobile');
            $(document).off('.menuMobileClose');
            $(document).off('.menuL1Accordion');

            // for L1 catagories

            var $dropdownToggleMain = $('header .navbar-nav .dropdown:not(.disabled)');
            $dropdownToggleMain.add('.category-backdrop').off('.menuDesktop').on('mouseenter.menuDesktop', function () {
                const $parent = $(this).closest('.dropdown');

                loadMenuItem($parent).done(function () {
                    meganavResponsive();
                    if ($parent.is(':hover')) {
                        openDesktopDropdown($parent);
                    }
                });
            }).closest('.dropdown')
                .on('mouseleave.menuDesktop', function () {
                    closeDesktopDropdown($(this));
                });

            // for L2 catagories
            $('.l2-category-item').off('.menuDesktop').on('mouseenter.menuDesktop', function () {
                resetL2FlyoutDesk();
                $(this).find('.category-tabs-modal').removeClass('d-none');
                $(this).addClass('show');
                $(this).find('.right-arrow').removeClass('d-none');
            }).on('mouseleave.menuDesktop', function () {
                const $parent = $(this).find('.modal-content-overlay');
                resetL3MenuTabs($parent);
            });

            $('.l2-category-items').off('.menuDesktop').on('mouseleave.menuDesktop', function () {
                $(this).scrollTop(0);
                $('.category-backdrop').addClass('d-lg-none'); // clossing l2(main flyout), after leaving l2 section
                resetL2FlyoutDesk();
            });

            if (!isTouchDevice) { // Desktop or non-touch devices: use hover
                $('.top-navbar-right .more-div, .more-active-section').off('.menuDesktop').on('mouseenter.menuDesktop', function () {
                    $('.more-section-accodian-body .countrys-wrap-list').scrollTop(0);
                    $('.more-section-accodian-body').removeClass('show');
                    $('.more-first-set-accordian').addClass('collapsed');
                    $('.more-active-section').removeClass('collapse');
                }).on('mouseleave.menuDesktop', function () {
                    $('.more-active-section').addClass('collapse');
                    $('.country-region-container').scrollTop(0);
                });
            } else { // Mobile or touch devices: use click toggle
                $(document).off('click.menuDesktop').on('click.menuDesktop', function (event) {
                    if (!$(event.target).closest('.top-navbar-right .more-div, .more-active-section').length) {
                        $('.more-active-section').addClass('collapse');
                        $('.country-region-container').scrollTop(0);
                    }
                });
            }

            $('.open-country-modal').off('.menuDesktop').on('click.menuDesktop', function () {
                var clickedRegion = $(this).data('region');

                // ---------- Country modal logic ----------
                var countries = $('.country-data-list[data-region="' + clickedRegion + '"]').first().find('.country-item');
                $('#dynamicCountryList').empty();

                countries.each(function () {
                    var name = $(this).data('country');
                    var abbreviation = $(this).data('abbreviation');
                    var imageURL = $(this).data('image');
                    var currencyCode = $(this).data('currencycode');
                    var isSelectedCountry = selectedGeographyCountry && selectedGeographyCountry === abbreviation;
                    var selectedClass = isSelectedCountry ? ' selected' : '';
                    $('#dynamicCountryList').append('<li class="main-texts col-4 countries d-flex align-items-center" data-abbreviation="' + abbreviation + '" data-currencycode="' + currencyCode + '"><img src="' + imageURL + '" alt="' + name + '" /><span class="country-name' + selectedClass + '">' + name + '</span></li>');
                    if (window.innerWidth >= 1024) {
                        $('#regionModal').modal('show');
                        $('#regionModal').removeClass('d-none');
                    }
                });
                updateSelectedCountryStyles(selectedGeographyCountry);
            });
        }
    }

    if (isTouchDevice) {
        $('.top-navbar-right .more-div').on('click', function () {
            $('.more-active-section').toggleClass('collapse');
            $('.more-section-accodian-body .countrys-wrap-list').scrollTop(0);
            $('.more-section-accodian-body').removeClass('show');
            $('.more-first-set-accordian').addClass('collapsed');
        });
    }

    $(document).ready(function () {
        selectedGeographyCountry = ($('.geography-section .geography-flag').attr('data-selectedregion') || '').toUpperCase();

        meganavResponsive();
        updateSelectedCountryStyles(selectedGeographyCountry);

        $('.more-section-accodian-body').on('hide.bs.collapse', function () {
            $('.more-section-accodian-body .countrys-wrap-list, .country-region-container').scrollTop(0);
        });

        $('.footer-services').toggleClass('d-none', selectedGeographyCountry !== 'IN');
    });

    $(window).on('resize', function () {
        meganavResponsive();
        closeMegaNavInResponsive();
    });

    $('body').on('hide.bs.modal', '#regionModal', function () {
        $('#dynamicCountryList').scrollTop(0); // Reset scroll position of country list
    });

    $('.menu-div').on('click', function () {
        $('.mob-nav .header-navbar').addClass('show-mobile-menu'); // opens meganav on mobile
        $('body').addClass('overflow-hidden');
        $('.modal-background').show();
        $('.metal-rates-header-banner, .metal-rate').removeClass('show');
        $('.metal-rates-header-banner').css('height', '0px');
        if ($('.custom-drop-down').hasClass('opened') || $('.refinement-bar').css('display') === 'block') {
            $('.custom-option-values').fadeOut();
            $('.custom-drop-down').removeClass('opened');
            $('.refinement-bar').hide();
        }
    });

    $('.top-navbar-right .menu-div').on('click', function () {
        $('body').addClass('mob-nav-category-active');
    });

    $('body').on('click', '#dynamicCountryList .countries, .country-item.country-flag-and-name', function () {
        var $this = $(this);
        var imageUrl = $this.find('img').attr('src');
        var regionKey = $this.data('abbreviation');
        var currencyCode = $this.data('currencycode');
        var url = $('#dynamicCountryList').data('url');

        countryFlagSet(imageUrl, regionKey, currencyCode, url);
    });

    $('.country-region-container .country-region').on('click', function () {
        var $this = $(this);
        var target = $this.data('target');

        if (target === '#countries-accordion-India') {
            var imageUrl = $this.data('imgurl');
            var regionKey = 'IN';
            var currencyCode = 'INR';
            var url = $('#dynamicCountryList').data('url');

            countryFlagSet(imageUrl, regionKey, currencyCode, url);
        }
    });
};
